import React from 'react';
import Skeleton from '../../../../shared/components/ui/Skeleton/Skeleton';

export const StatCardSkeleton = () => (
    <div className="skeleton-stat-card">
        <Skeleton variant="circle" width={40} height={40} />
        <div style={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" height={12} />
            <Skeleton variant="text" width="70%" height={20} />
        </div>
    </div>
);

export const ProposalCardSkeleton = () => (
    <div className="skeleton-card-container">
        <Skeleton variant="rect" className="skeleton-thumbnail" />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="rect" width={80} height={24} style={{ borderRadius: '20px' }} />
        </div>
        <Skeleton variant="text" width="40%" height={14} />
        <Skeleton variant="text" width="90%" height={12} />
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton variant="text" width="30%" height={12} />
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <Skeleton variant="circle" width={24} height={24} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <Skeleton variant="text" width={60} height={10} />
                    <Skeleton variant="text" width={40} height={8} />
                </div>
            </div>
        </div>
    </div>
);

export const AssignmentRowSkeleton = () => (
    <div className="assignment-row" style={{ pointerEvents: 'none', cursor: 'default', display: 'grid' }}>
        {/* Col 1: Sl No */}
        <div className="row-col col-sl">
            <Skeleton variant="text" width={24} height={16} />
        </div>

        {/* Col 2: Proposal Title */}
        <div className="row-col col-main">
            <Skeleton variant="text" width="80%" height={16} style={{ marginBottom: '4px' }} />
            <Skeleton variant="text" width="60%" height={16} />
        </div>

        {/* Col 3: Section Name */}
        <div className="row-col col-section">
            <Skeleton variant="text" width="70%" height={14} />
        </div>

        {/* Col 4: Status */}
        <div className="row-col col-status" style={{ alignItems: 'center' }}>
            <Skeleton variant="rect" width={100} height={24} style={{ borderRadius: '12px' }} />
        </div>

        {/* Col 5: Due Date */}
        <div className="row-col col-due">
            <Skeleton variant="text" width={80} height={14} />
        </div>

        {/* Col 6: Actions */}
        <div className="row-col col-actions">
            <Skeleton variant="circle" width={36} height={36} />
        </div>
    </div>
);

const DashboardSkeleton = ({ isManager = true }) => {
    return (
        <div className="proposals-page">
            <div className="proposals-header" style={{ marginBottom: '2rem' }}>
                <div className="header-left">
                    <Skeleton variant="text" width={200} height={32} />
                    <Skeleton variant="text" width={300} height={16} />
                </div>
            </div>

            <div className="dashboard-summary-row" style={{ marginBottom: '2rem', gridTemplateColumns: isManager ? 'repeat(4, 1fr)' : 'repeat(6, 1fr)' }}>
                {[...Array(isManager ? 4 : 6)].map((_, i) => <StatCardSkeleton key={i} />)}
            </div>

            <div className="table-container-main">
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
                    <Skeleton variant="rect" width={300} height={40} style={{ borderRadius: '20px' }} />
                    <div style={{ flex: 1 }} />
                    <Skeleton variant="rect" width={100} height={32} style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rect" width={100} height={32} style={{ borderRadius: '20px' }} />
                </div>

                {isManager ? (
                    <div className="proposals-grid">
                        {[...Array(6)].map((_, i) => <ProposalCardSkeleton key={i} />)}
                    </div>
                ) : (
                    <div className="assignments-table-view">
                        <div className="assignments-header-row">
                            <div className="header-col col-sl">Sl No</div>
                            <div className="header-col col-main">Proposal Title</div>
                            <div className="header-col col-section">Section Name</div>
                            <div className="header-col col-status">Status</div>
                            <div className="header-col col-due">Due Date</div>
                            <div className="header-col col-actions"></div>
                        </div>
                        <div className="assignments-list">
                            {[...Array(5)].map((_, i) => <AssignmentRowSkeleton key={i} />)}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardSkeleton;
